(ns minorodata.components.ui.core
  (:require
   [applied-science.js-interop :as jsi]
   [lucide-react :refer [ChevronDown Database Play Plus Trash2 User]]
   [re-frame.core :as re-frame]
   [re-posh.core :as re-posh]
   [reagent.core :as reagent]
   [ui.button :refer [button]]
   [ui.datepicker :refer [datetime-picker]]
   [ui.fields :refer [checkbox input radio-group select switch]]
   [ui.page :refer [page-content page-root]]
   [ui.tabs :refer [tabs tabs-content tabs-list tabs-root tabs-trigger]]
   [ui.typography :refer [h1 h2 typography]]))

(defn buttons
  []
  [:div {:class "flex flex-col gap-8"}
   [:header [h1 "Buttons"]]
   [:div {:class "flex gap-8 flex-wrap"}
    [:section
     [:header {:class "mb-4"} [h2 "Primary (default)"]]
     [:div {:class "flex gap-2"}
      [button {} "Active"]
      [button {:loading true} "Loading"]
      [button {:disabled true} "Disabled"]]]

    [:section
     [:header {:class "mb-4"} [h2 "Secondary"]]
     [:div {:class "flex gap-2"}
      [button {:variant :secondary} "Active"]
      [button {:variant :secondary :loading true} "Loading"]
      [button {:variant :secondary :disabled true} "Disabled"]]]

    [:section
     [:header {:class "mb-4"} [h2 "Error"]]
     [:div {:class "flex gap-2"}
      [button {:variant :error} "Active"]
      [button {:variant :error :loading true} "Loading"]
      [button {:variant :error :disabled true} "Disabled"]]]

    [:section
     [:header {:class "mb-4"} [h2 "Warning"]]
     [:div {:class "flex gap-2"}
      [button {:variant :warning} "Active"]
      [button {:variant :warning :loading true} "Loading"]
      [button {:variant :warning :disabled true} "Disabled"]]]

    [:section
     [:header {:class "mb-4"} [h2 "Empty"]]
     [:div {:class "flex gap-2"}
      [button {:variant :empty} "Active"]
      [button {:variant :empty :loading true} "Loading"]
      [button {:variant :empty :disabled true} "Disabled"]]]


    [:section
     [:header {:class "mb-4"} [h2 "With icons"]]
     [:div {:class "flex gap-2"}
      [button {:variant :secondary
               :icon    Play}
       "Preview"]
      [button {:icon    Plus}
       "Create in SQL Console"]
      [button {:variant    :secondary
               :icon-right ChevronDown}
       "Show more"]
      [button {:variant    :error
               :icon-right Trash2}
       "Delete"]]]

    [:section
     [:header {:class "mb-4"} [h2 "Sizes"]]
     [:div {:class "flex items-center gap-2"}
      [button {:size :small :icon Play} "Small"]
      [button {:icon Play} "Regular"]
      [button {:size :large :icon Play} "Large"]]]]])

(defn tabs'
  []
  [:div {:class "flex flex-col gap-8"}
   [:header [h1 "Tabs"]]
   [:div {:class "flex flex-wrap gap-8"}
    [:section
     [:header {:class "mb-4"} [h2 "Default"]]
     [:div {:class "flex gap-2"}
      [tabs {:default-value "v1"
             :variant       :underlined
             :size          :default
             :tabs          [{:value   "v1"
                              :label   "Transforms"
                              :content [:div {:class "mt-4"} "VALUE 1"]}
                             {:value   "v2"
                              :label   "Extracts"
                              :content [:div {:class "mt-4"} "VALUE 2"]}
                             {:value   "v3"
                              :label   "All"
                              :content [:div {:class "mt-4"} "VALUE 3"]}]}]]]

    [:section
     [:header {:class "mb-4"} [h2 "Custom (bordered)"]]
     [:div {:class "flex gap-2"}
      [tabs-root {:default-value "V1"}
       [tabs-list {}
        [tabs-trigger {:value "V1"} "Transforms"]
        [tabs-trigger {:value "V2"} "Extracts"]]

       [tabs-content {:value "V1"} [:div {:class "mt-4"} "VALUE 1"]]
       [tabs-content {:value "V2"} [:div {:class "mt-4"} "VALUE 2"]]]]]

    [:section
     [:header {:class "mb-4"} [h2 "Underlined"]]
     [:div {:class "flex gap-2"}
      [tabs-root {:default-value "V1"}
       [tabs-list {:variant :underlined}
        [tabs-trigger {:value "V1" :variant :underlined} "Transforms"]
        [tabs-trigger {:value "V2" :variant :underlined} "Extracts"]]

       [tabs-content {:value "V1"} [:div {:class "mt-4"} "VALUE 1"]]
       [tabs-content {:value "V2"} [:div {:class "mt-4"} "VALUE 2"]]]]]

    [:section
     [:header {:class "mb-4"} [h2 "Large"]]
     [:div {:class "flex gap-2"}
      [tabs-root {:default-value "V1"}
       [tabs-list {:variant :underlined
                   :size    :large
                   :tabs    [{:value "V1" :label "Transforms"}
                             {:value "V2" :label "Extracts"}]}]

       [tabs-content {:value "V1"} [:div {:class "mt-4"} "VALUE 1"]]
       [tabs-content {:value "V2"} [:div {:class "mt-4"} "VALUE 2"]]]]]

    [:section {:class "flex-1"}
     [:header {:class "mb-4"} [h2 "Full Width"]]
     [:div {:class "flex gap-2"}
      [tabs-root {:default-value "V1"
                  :full-width true}
       [tabs-list {:variant    :underlined
                   :full-width true
                   :size       :large
                   :tabs       [{:value "V1" :label "Transforms"}
                                {:value "V2" :label "Extracts"}]}]

       [tabs-content {:value "V1"} [:div {:class "mt-4"} "VALUE 1"]]
       [tabs-content {:value "V2"} [:div {:class "mt-4"} "VALUE 2"]]]]]]])

(defn inputs
  []
  [:div {:class "flex flex-col gap-8"}
   [:header [h1 "Forms - Inputs"]]
   [:div {:class "flex gap-6"}
    [:section
     [:header {:class "mb-4"} [h2 "Default"]]
     [:div {:class "flex gap-2"}
      [input {:label       "Field label"
              :required    true
              :placeholder "Placeholder value"
              :type        "email"}]]]
    [:section
     [:header {:class "mb-4"} [h2 "Error"]]
     [:div {:class "flex gap-2"}
      [input {:label    "Field label"
              :id       "email"
              :required true
              :errors   {"email" "Incorrect email syntax"}
              :type     "email"}]]]
    [:section
     [:header {:class "mb-4"} [h2 "Helper text"]]
     [:div {:class "flex gap-2"}
      [input {:label    "Field label"
              :id       "email"
              :helper    [:a {:href "" :class "underline"} "See documentation"]
              :type     "email"}]]]
    [:section
     [:header {:class "mb-4"} [h2 "Disabled"]]
     [:div {:class "flex gap-2"}
      [input {:label    "Field label"
              :id       "email"
              :disabled true
              :field    {:value "Non-editable value"}
              :type     "email"}]]]
    [:section
     [:header {:class "mb-4"} [h2 "Non labeled"]]
     [:div {:class "flex gap-2"}
      [input {:id       "email"
              :field    {:value "This input has no label"}
              :type     "email"}]]]]
   [:section
    [:header {:class "mb-4"} [h2 "Full width"]]
    [:div {:class "flex gap-2"}
     [input {:id         "email"
             :label      "Field label"
             :full-width true
             :field      {:value "OMG so much space"}
             :type       "email"}]]]

   [:div {:class "flex gap-6"}
    [:section
     [:header {:class "mb-4"} [h2 "With icon"]]
     [:div {:class "flex gap-2"}
      [input {:id         "email"
              :label      "Field label"
              :icon       User
              :field      {:value "Input with an icon"}
              :type       "email"}]]]
    [:section
     [:header {:class "mb-4"} [h2 "With icon right"]]
     [:div {:class "flex gap-2"}
      [input {:id         "email"
              :label      "Field label"
              :icon-right Database
              :field      {:value "Input with an icon"}
              :type       "email"}]]]

    [:section
     [:header {:class "mb-4"} [h2 "Sizes"]]
     [:div {:class "flex gap-2"}
      [input {:id         "email"
              :label      "Field label"
              :icon       User
              :field      {:value "Regular"}
              :type       "email"}]
      [input {:id         "email"
              :label      "Field label"
              :icon       User
              :size       :large
              :field      {:value "Large"}
              :type       "email"}]]]
    [:section {:class "flex-1"}
     [:header {:class "mb-4"} [h2 "Textarea"]]
     [:div {:class "flex gap-2"}
      [input {:id         "email"
              :label      "Field label"
              :textarea   true
              :full-width true
              :field      {:value "Input with an icon"}
              :type       "email"}]]]]])

(defn selects
  []
  (let [options (mapv #(-> {:value (str "v" %) :text (str "Value " %)}) (range 100))]
    [:div {:class "flex flex-col gap-8"}
     [:header [:h1 {:class "text-2xl font-bold"}
               "Forms - Selects"]]
     [:div {:class "flex gap-6"}
      [:section
       [:header {:class "mb-4"} [h2 "Native"]]
       [:div {:class "flex gap-2"}
        [select {:label       "Field label"
                 :id          "native"
                 :field       {:value "v1"}
                 :required    true
                 :options     options}]]]
      [:section
       [:header {:class "mb-4"} [h2 "Custom"]]
       [:div {:class "flex gap-2"}
        [select {:label       "Field label"
                 :id          "native"
                 :native      false
                 :field       {:value "1"
                               :action (fn [v]
                                         (println (type v))
                                         (println v))}
                 :options     [{:text "None" :value nil}
                               {:text "1" :value "1"}]}]
        [select {:label       "Disabled"
                 :id          "native"
                 :native      false
                 :disabled    true
                 :field       {:value "v1"}
                 :options     options}]]]
      [:section
       [:header {:class "mb-4"} [h2 "Sizes"]]
       [:div {:class "flex gap-2"}
        [select {:label       "Regular"
                 :id          "native"
                 :native      false
                 :field       {:value "v1"}
                 :options     options}]
        [select {:label       "Large"
                 :id          "native"
                 :native      false
                 :size        :large
                 :field       {:value "v1"}
                 :options     options}]]]]]))

(defn checkboxes
  []
  (let [v (reagent/atom false)
        on-change #(reset! v %)]
    (fn []
      [:div {:class "flex flex-col gap-8"}
       [:header [h1 "Forms - Checkboxes"]]
       [:div {:class "flex gap-6"}
        [:section
         [:header {:class "mb-4"} [h2 "Default"]]
         [:div {:class "flex flex-col gap-2"}
          [checkbox {:label       "Off"
                     :id          "native"
                     :field       {:value @v
                                   :action on-change}
                     :required    true}]
          [checkbox {:label       "On"
                     :id          "native2"
                     :field       {:value true
                                   :action (fn [])}
                     :required    true}]
          [checkbox {:label       "Disabled"
                     :id          "native3"
                     :field       {:value @v
                                   :action on-change}
                     :disabled    true}]]]]])))
(defn radio-buttons
  []
  (let [v (reagent/atom "1")
        on-change #(reset! v %)]
    (fn []
      [:div {:class "flex flex-col gap-8"}
       [:header [h1 "Forms - Radio"]]
       [:div {:class "flex gap-6"}
        [:section
         [:header {:class "mb-4"} [h2 "Default"]]
         [:div {:class "flex flex-col gap-8"}
          [radio-group {:id          "native"
                        :field       {:value @v
                                      :action on-change}
                        :options     [{:value "1" :text "Option 1"}
                                      {:value "2" :text "Option 2"}
                                      {:value "3" :text "Option 3"}]
                        :required    true}]]]
        [:section
         [:header {:class "mb-4"} [h2 "Disabled"]]
         [:div {:class "flex flex-col gap-2"}
          [radio-group {:id          "native2"
                        :disabled    true
                        :field       {:value @v
                                      :action on-change}
                        :options     [{:value "1" :text "Option 1"}
                                      {:value "2" :text "Option 2"}
                                      {:value "3" :text "Option 3"}]
                        :required    true}]]]]])))

(defn typography'
  []
  [:div {:class "flex flex-col gap-8"}
   [:header [h1 "Typography"]]
   [:div {:class "flex gap-6"}
    [:section {:class "flex flex-col"}
     [typography {:variant :h1} "Header 01"]
     [typography {:variant :h2} "Header 02"]
     [typography {:variant :h3} "Header 03"]
     [typography {:variant :h4} "Header 04"]
     [typography {:variant :p} "Body text"]
     [typography {:variant :small} "Small text"]
     [typography {:variant :label} "Label"]]]])

(defn date-pickers
  []
  (let [dates-range (reagent/atom [])
        set-dates-range #(reset! dates-range %)]
    (fn []
      [:div {:class "flex flex-col gap-8"}
       [:header [h1 "Date pickers"]]
       [:div {:class "flex gap-6"}
        [:section {:class "flex flex-col"}
         [datetime-picker {:label      "Filter by date"
                           :value     @dates-range
                           :on-change  set-dates-range}]]]])))

(defn switches []
  (let [selected (reagent/atom false)]
    (fn []
      [:div {:class "flex flex-col gap-8"}
       [:header [h1 "Switches"]]
       [:div {:class "flex gap-6"}
        [:section {:class "flex flex-col"}
         [:div {:class "flex items-center gap-2"}
          [switch {:id       :switch
                   :label    (if @selected "On" "Off")
                   :value    @selected
                   :on-click #(swap! selected not)}]]]]])))


(defn toast-messages []
  [:div {:class "flex flex-col gap-8"}
   [:header [h1 "i-frame events tester"]]
   [:div {:class "flex gap-6"}
    [:section {:class "flex flex-row gap-12"}
     [:div {:class "flex flex-col gap-2"}
      [:a {:href "#"
           :on-click (fn []
                       (re-frame/dispatch [:app.events/add-snack :success "A success message"]))}
       "Success toast"]

      [:a {:href "#"
           :on-click (fn []
                       (re-frame/dispatch [:app.events/add-snack :warning "A warning message"]))}
       "Warning toast"]

      [:a {:href "#"
           :on-click (fn []
                       (re-frame/dispatch [:app.events/add-snack :error "An error message  a very very long formatted message\nkaosdkpo\niaoijdaoid \nkaposdkaposdk oaksdpo kapsodkpa oskdpaok poaks doakspd oaks d\n ijaosidj asd"]))}
       "Error toast"]]]]])


(defn iframe-controls []
  (let [route @(re-posh/subscribe [:app-route/pull])
        {:app-route/keys [query name]} route]
    [:div {:class "flex flex-col gap-8"}
     [:header [h1 "i-frame events tester"]]
     [:div {:class "flex gap-6"}
      [:section {:class "flex flex-row gap-12"}
       [:div {:class "flex flex-col gap-2"}
        [:a {:href "#"
             :on-click (fn []
                         (jsi/call-in js/window [:parent :postMessage]
                                      #js {:type "open-console"}
                                      "*"))}
         "Open console"]

        [:a {:href "#"
             :on-click (fn []
                         (jsi/call-in js/window [:parent :postMessage]
                                      #js {:type "close-console"}
                                      "*"))}
         "Close console"]

        [:a {:href "#"
             :on-click (fn []
                         (jsi/call-in js/window [:parent :postMessage]
                                      #js {:type "open-new-console-tab"
                                           :params #js {:code "SELECT 3.14 AS NEW_TAB;\n\n-- yolo"}}
                                      "*"))}
         "New tab with code"]

        [:a {:href "#"
             :on-click (fn []
                         (jsi/call-in js/window [:parent :postMessage]
                                      #js {:type "create-toast"
                                           :params #js {:level "error"
                                                        :message "All is lost"}}
                                      "*"))}
         "Toast.error"]

        [:a {:href     "#"
             :on-click (fn []
                         (jsi/call-in js/window [:parent :postMessage]
                                      #js {:type "create-toast"
                                           :params #js {:level "success"
                                                        :message "ok cool"}}
                                      "*"))}
         "Toast.success"]]

       [:div {:class "flex flex-col gap-2"}
        [:p name]
        [:p (str query)]
        [:a {:href "/ui"}
         "go to root page"]
        [:a {:href "/ui?db=TEST_DB&schema=SCHEMA_SCHEMA&table=TABLE_LOL"}
         "go to page with params"]]]]]))


(defn sentry []
  [:div {:class "flex flex-col gap-8"}

   [:header [h1 "Sentry event tester"]]
   [:div {:class "flex gap-6"}
    [:a {:href "#"
         :on-click (fn []
                     (re-frame/dispatch [:sentry/capture-message "HELLO"]))}
     "Capture message"]

    [:a {:href "#"
         :on-click (fn []
                     (re-frame/dispatch [:sentry/capture-event {:message "Event sent" :stacktrace ["OK" "hello"]}]))}
     "Capture event"]

    [:a {:href "#"
         :on-click (fn []
                     (throw (js/Error. "Testing Sentry errors")))}
     "Throw error"]]])


(defn connectors-research []
  (let [connectors @(re-frame/subscribe [:connections.subs/current-connectors-unfiltered])
        forms (map :extract-form connectors)
        definitions (map :blocks forms)
        all-blocks (flatten definitions)

        filtered_type :autocomplete-chips

        filtered (filter (fn [b]
                           (:multiple b)
                           (= filtered_type (:block-type b)))
                         all-blocks)]
    [:div
     [:header [h1 "Connectors research"]]

     [:p "All loaded extract form blocks: " (count all-blocks)]
     [:p "Of them, just " (str filtered_type)  " : " (count filtered)]

     ; [:p (str (map (juxt :block-type :label) filtered))]

     #_[:p (str (->> (map :options filtered)
                     flatten
                     (map :value)
                     (filter #(= "" %))
                     count
                   ; distinct
                     ))]]))

(defn page
  []
  [page-root
   [page-content {:class "flex flex-col gap-16"}
    [connectors-research]
    [sentry]
    [toast-messages]
    [iframe-controls]
    [buttons]
    [tabs']
    [inputs]
    [selects]
    [checkboxes]
    [radio-buttons]
    [date-pickers]
    [switches]
    [typography']]])
